enum CardRule {
  None = 10, //Done
  Bomb = 1, //Done
  NoMagic = 2, // Done
  NoSpeech = 3, // Done
  SinglePile = 4, // Done
  Stop = 5, // Done
  MustPlaceThreeCards = 6, // Done
  DrawOnlyOneCard = 7,
  Skull = 8, // Done
}

export default CardRule;
